module.exports = __webpack_public_path__ + "static/img/5.76a6b1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/5.jpg
// module id = 2mmw
// module chunks = 4